export default __webpack_public_path__ + "static/feature-bg-6767e2557cf6917b9b37efb8b5b25c45.png";